module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "book-subtitle",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Ron Carlson Writes a Story")])]), _vm._v(" "), _c('p', {
    staticClass: "book-subtitle",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Tips from a Master of the Craft")]), _vm._v(" "), _c('p', {
    staticClass: "book-author_print-only",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Ron Carlson")])]), _vm._v(" "), _c('p', {
    staticClass: "book-author_print-only",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('img', {
    attrs: {
      "src": "image/logo.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19744b20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RonCarlson-24.vue
// module id = 63
// module chunks = 0